// extracted by mini-css-extract-plugin
module.exports = {"section15":"Section15_section15__a_FLH"};